/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Furniture(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.001 1.5C15.5533 1.5 16.001 1.94772 16.001 2.5V9.01465C16.474 9.09392 16.835 9.50444 16.835 10C16.835 10.5179 16.441 10.9441 15.9365 10.9951L15.835 11H15.335L11.668 13.75L15.6016 16.7002C16.043 17.0315 16.1326 17.6579 15.8018 18.0996C15.4704 18.5414 14.8432 18.6312 14.4014 18.2998L10.001 14.999L5.60156 18.2998L5.5166 18.3574C5.08248 18.6189 4.51181 18.5138 4.20117 18.0996C3.87021 17.6579 3.95983 17.0315 4.40137 16.7002L8.33496 13.75L4.66797 11H4.16797C3.61577 10.9999 3.16797 10.5522 3.16797 10C3.16797 9.50473 3.52834 9.09426 4.00098 9.01465V2.5C4.00098 1.94789 4.44893 1.50028 5.00098 1.5C5.55326 1.5 6.00098 1.94772 6.00098 2.5V3.16699H14.001V2.5C14.001 1.94789 14.4489 1.50028 15.001 1.5ZM10.001 12.5L12.002 11H8.00098L10.001 12.5ZM6.00098 9H14.001V7.66699H6.00098V9ZM6.00098 5.66699H14.001V5.16699H6.00098V5.66699Z"
        fill="#35424F"
      />
    </svg>
  )
}

Furniture.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Furniture
